import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'ipm-bpm-arena-beats',
  templateUrl: './bpm-arena-beats.component.html',
  styleUrls: ['./bpm-arena-beats.component.scss']
})
export class BpmArenaBeatsComponent implements OnInit {
  @Input() bannerHeading: string = "";
  @Input() bannerDiscount: string = "";
  @Input() isShowBanner: boolean =  false;
  @Input() type: string;
  @Input() beatListData: Array<any> = [];
  @Input() isShowing: string = "grid";

  customOptions: OwlOptions = {
      center: false,
      responsiveRefreshRate: 0,
      dots:false,
      mergeFit: true,
      lazyLoad: true,
      margin:30,
      items:3,
      slideBy: 3,
      navText: ["", ""],
      responsive:{
          0:{
              items:1,
              slideBy:1,
              autoplay: true,
              dots:true,
          },
          565 :{
            items:1,
            slideBy:1,
            autoplay: true,
            dots:true,
          },
          767: {
            items:1,
            slideBy:1,
            autoplay: true,
            dots:true,
          },
          992 : {
            items:1,
            slideBy:1,
            autoplay: true,
            dots:true,
          },
          1250:{
              items:3,
              slideBy:3
          }
      }
  }

  constructor(private router: Router,
  private routerActivate: ActivatedRoute) {}

  ngOnInit(): void { }

  /**
   * Go to latest beat according to discount tries
   * @param currentButtonClick 
   */
  gotoLatestBeat(currentButtonClick: string) {
    let params = {
      bpmOffer: currentButtonClick
    }
    this.router.navigate(['/latestbeats'], { relativeTo: this.routerActivate ,queryParams: params});
  }

}
